<template>
  <div>
    <a-spin :spinning="loading">
      <div class="max-w-8xl mx-auto">
        <div>
          <div>
            <TabSelector :tabs="tabs" @tabSelected="handleTabSelected" :currentIndex="currentIndex"
                         @searchText="searchText"/>
            <ul role="list" class="mt-5 border-t border-gray-200 divide-gray-200 sm:mt-0 sm:border-t-0">
              <transition-group name="list" tag="p">
                <li v-for="action in actions" :key="action.action_id">
                  <ActionCard :action="action" @fetchActions="fetchActions" :roomId="roomId"
                              :currentTabIndex="currentIndex"/>
                </li>
              </transition-group>
            </ul>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import {onMounted, ref} from 'vue'

import {message} from "ant-design-vue";
import ActionCard from "./Components/ActionCard";
import TabSelector from "./Components/TabSelector";
import TeamSelectionDropdown from "@/Layouts/TeamSelectionDropdown";
import NoTeamAlert from "@/Pages/Retrospective/Components/NoTeamAlert";

const CURRENT = 0
const TODO = 1;
const COMPLETED = 2;
const ALL = 3;
export default {
  components: {
    NoTeamAlert,
    TeamSelectionDropdown,
    TabSelector,
    ActionCard,
  },
  props: ['roomId', 'type'],
  setup(props) {
    const loading = ref(false);
    const actions = ref([]);
    const currentIndex = ref(TODO);
    const {roomId, type} = props;

    const tabs = ref([
      {name: 'Current', count: '0', key: 'current', isEnabled: !!props.roomId, index: CURRENT},
      {name: 'Todo', count: '0', key: 'todo', isEnabled: true, index: TODO},
      {name: 'Completed', count: '0', key: 'is_done', isEnabled: true, index: COMPLETED},
      {name: 'All', count: '0', key: 'all', isEnabled: true, index: ALL},
    ]);

    if (roomId) {
      currentIndex.value = CURRENT;
    }

    const actionConcern = () => {
      switch (type) {
        case 'team':
          return axios.get(route("retrospective.action.board.get.team"));
        case 'public':
          return axios.get(route("retrospective.action.board.get.public"));
        case 'room':
          return axios.get(route("retrospective.action.board.get"), {
            params: {
              room_id: props.roomId
            }
          });
        default:
          throw new Error('error');
      }
    }
    const fetchActions = async () => {
      loading.value = true;

      await actionConcern()
          .then((response) => {
            loading.value = false;
            actions.value = getFilteredDataByTabIndex(response.data.data,currentIndex.value)
            setCountData(response.data.data);
          })
          .catch((error) => {
            loading.value = false;
            console.log(error);
            message.error('Our system cannot fetch your boards data. Please contact us.', 5);
          });
    }

    const setCountData = (rawActions) => {
      tabs.value.forEach(tab => {
        tab.count = getFilteredDataByTabIndex(rawActions, tab.index).length.toString();
      });
    }

    const getFilteredDataByTabIndex = (rawActions, tabIndex) => {
      if (tabIndex === CURRENT) {
        return rawActions.filter((item) => item.room_id == props.roomId)
      } else if (tabIndex === TODO) {
        return rawActions.filter((item) => item.is_done === false)
      } else if (tabIndex === COMPLETED) {
        return rawActions.filter((item) => item.is_done === true)
      }
      return rawActions;
    }

    onMounted(() => {
      fetchActions();
    });

    const searchText = async (key) => {
      currentIndex.value = ALL;
      await fetchActions();
      console.log(key);
      actions.value = actions.value.filter(function (e) {
        return e.action.toLowerCase().includes(key.toLowerCase());
      });
    }

    const handleTabSelected = (tab) => {
      loading.value = true;
      currentIndex.value = tab.index;
      fetchActions();
    };

    const handleToggleAction = (tab, roomId) => {
      loading.value = true;
      console.log(tab);
      fetchActions();
    };

    return {
      searchText,
      actions,
      handleTabSelected,
      handleToggleAction,
      loading,
      fetchActions,
      tabs,
      currentIndex
    };
  },
}
</script>
<style scoped>
.list-item {
  display: inline-block;
  margin-right: 10px;
}

.list-enter-active, .list-leave-active {
  transition: all 0.2s;
}

.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateY(30px);
}

</style>